import { RouterModal } from "@/components/General/Modal/routerModal";
import { TextContainer } from "@/components/General/Text/text.container";
import { ModalType } from "@/redux/modules/value/modal/modal.types";

type Props = {
    modalId: ModalType;
    title: string;
    text: string;
    color: string;
    className?: string;
};

export const RichTextModal = ({
    modalId,
    title,
    text,
    color,
    className
}: Props) => {
    return (
        <RouterModal
            modalType={modalId}
            title={title}
            className={className}
        >
            <TextContainer
                text={text}
                color={color}
            />
        </RouterModal>
    );
};
